import { render, staticRenderFns } from "./PcErrorAlert.vue?vue&type=template&id=feb04436"
import script from "./PcErrorAlert.vue?vue&type=script&lang=js"
export * from "./PcErrorAlert.vue?vue&type=script&lang=js"
import style0 from "./PcErrorAlert.vue?vue&type=style&index=0&id=feb04436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
